import script from "./whDOnceImg3_t1A.vue?vue&type=script&setup=true&lang=js"
export * from "./whDOnceImg3_t1A.vue?vue&type=script&setup=true&lang=js"

import "./whDOnceImg3_t1A.vue?vue&type=style&index=0&id=2089f215&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2089f215"]])

export default __exports__